import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { NAVIGATION_TABS } from '../constants'
import { StateType } from '../state'
import { PillButton } from '../../../components/ui/PillButton'

interface Props {
  state?: StateType
}

@inject('state')
@observer
export class NavigationTabs extends React.Component<Props> {
  render() {
    const { selectedNavTab, setSelectedNavTab } = this.props.state.Circles

    return (
      <div className="-navigation-tabs flex justify-center-ns w-100 overflow-x-auto">
        <div className="flex flex-nowrap add-prod-padding">
          {NAVIGATION_TABS.map(({ name, title }, i) => (
            <PillButton
              classNames="nowrap"
              key={name}
              label={title}
              enabled={selectedNavTab === name}
              onClick={() => setSelectedNavTab(name)}
            />
          ))}
        </div>
      </div>
    )
  }
}
